import { useSearchParams } from 'react-router-dom';
import ChatAgentForm from '../../../components/agents/ChatAgentForm/ChatAgentForm';
import Page from '../../../components/shared/Page/Page';

const NewChatAgent = () => {
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step');

  return (
    <Page withBackground hideMainMenu>
      <ChatAgentForm />
    </Page>
  );
};

export default NewChatAgent;
